import script from "./ClientReattachDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientReattachDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientReattachDropdown.vue?vue&type=style&index=0&id=47c5c64c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c5c64c"]])

export default __exports__